// Common error codes we want to return to the front-end
export const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
export const NOT_FOUND = 'NOT_FOUND';
export const BAD_REQUEST = 'BAD_REQUEST';
export const FORBIDDEN = 'FORBIDDEN';
export const SERVICE_ENOTFOUND = 'SERVICE_ENOTFOUND';
export const BAD_USER_INPUT = 'BAD_USER_INPUT';

// Object-specific error codes we want to return

// Authentication
export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const AUTH_ERROR = 'AUTH_ERROR';

// Application
export const APPLICATION_CREATION_FAILED = 'APPLICATION_CREATION_FAILED';
export const APPLICATION_GET_FAILED = 'APPLICATION_GET_FAILED';
// Stores
export const STORE_GET_ERROR = 'STORE_GET_ERROR';
export const STORE_CREATE_ERROR = 'STORE_CREATE_ERROR';
export const STORE_UPDATE_ERROR = 'STORE_UPDATE_ERROR';
export const STORE_DELETE_ERROR = 'STORE_DELETE_ERROR';
export const COMPANY_GET_ERROR = 'COMPANY_GET_ERROR';
export const COMPANY_CREATE_ERROR = 'COMPANY_CREATE_ERROR';
export const COMPANY_UPDATE_ERROR = 'COMPANY_UPDATE_ERROR';
// Payments
export const WALLET_NOT_FOUND = 'WALLET_NOT_FOUND';
export const PAYMENT_METHOD_NOT_FOUND = 'PAYMENT_METHOD_NOT_FOUND';
export const WALLET_GET_ERROR = 'WALLET_GET_ERROR';
export const WALLET_CREATE_ERROR = 'WALLET_CREATE_ERROR';
export const WALLET_UPDATE_ERROR = 'WALLET_UPDATE_ERROR';
export const PAYMENT_METHOD_ATTACH_ERROR = 'PAYMENT_METHOD_ATTACH_ERROR';
export const PAYMENT_METHOD_GET_ERROR = 'PAYMENT_METHOD_GET_ERROR';
export const PAYMENT_METHOD_CREATE_ERROR = 'PAYMENT_METHOD_CREATE_ERROR';
export const PAYMENT_METHOD_DELETE_ERROR = 'PAYMENT_METHOD_DELETE_ERROR';
export const PAYMENT_CHARGE_FAILED = 'PAYMENT_CHARGE_FAILED';
// Products
export const PRODUCT_GET_ERROR = 'PRODUCT_GET_ERROR';
export const PRODUCT_CLASS_GET_ERROR = 'PRODUCT_CLASS_GET_ERROR';
export const PRICE_LEVEL_GET_ERROR = 'PRICE_LEVEL_GET_ERROR';
// Orders
export const ORDER_GET_ERROR = 'ORDER_GET_ERROR';
export const ORDER_CREATION_FAILED = 'ORDER_CREATION_FAILED';
export const ORDER_UPDATE_FAILED = 'ORDER_UPDATE_FAILED';
// Line items
export const LINE_ITEM_GET_ERROR = 'LINE_ITEM_GET_ERROR';
// Roles
export const ROLE_GET_ERROR = 'ROLE_GET_ERROR';
// Shipping
export const SHIPPING_GET_ERROR = 'SHIPPING_GET_ERROR';
export const SHIPPING_SELECTION_GET_ERROR = 'SHIPPING_SELECTION_GET_ERROR';
export const SHIPPING_PURCHASE_FAILED = 'SHIPPING_PURCHASE_FAILED';
export const BAD_ADDRESS = 'BAD_ADDRESS';
// Users
export const USER_GET_ERROR = 'USER_GET_ERROR';
export const USER_CREATE_ERROR = 'USER_CREATE_ERROR';
export const USER_UPDATE_ERROR = 'USER_UPDATE_ERROR';
export const USER_DELETE_ERROR = 'USER_DELETE_ERROR';
// UserStoreRoles
export const USER_STORE_ROLE_GET_ERROR = 'USER_STORE_ROLE_GET_ERROR';
export const USER_STORE_ROLE_CREATE_ERROR = 'USER_STORE_ROLE_CREATE_ERROR';
export const USER_STORE_ROLE_UPDATE_ERROR = 'USER_STORE_ROLE_UPDATE_ERROR';
export const USER_STORE_ROLE_DELETE_ERROR = 'USER_STORE_ROLE_DELETE_ERROR';

// Case-specific error codes we want to return
// Checkout
export const STORE_ON_HOLD = 'STORE_ON_HOLD';
export const QUANTITY_BELOW_ZERO = 'QUANTITY_BELOW_ZERO';
export const CART_TOO_LARGE = 'CART_TOO_LARGE';
export const ORDER_DETAILS_MISMATCH = 'ORDER_DETAILS_MISMATCH';
